
import Vue from 'vue'
import {env, apiUrl} from '@/config/service'
import {Component} from 'vue-property-decorator'

@Component
export default class Env extends Vue {
  get env() {
    return env
  }

  get apiUrl() {
    return apiUrl
  }
}
